import { HubConnection } from '@microsoft/signalr';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { SendWebsocketMessage } from '../../../utils/websocketHelper';

export interface UpdateMessageThunkArg {
    connection: HubConnection;
    clubhouseId: number;
    selectedDiscussionId: number;
    messageText: string;
    messageId: number;
}

export const updateMessage = createAsyncThunk(
    'clubhouseMessages/update',
    async (arg: UpdateMessageThunkArg) => {
        let chatMessage = {
            clubhouseId: arg.clubhouseId,
            discussionId: arg.selectedDiscussionId,
            htmlContent: arg.messageText,
            messageId: arg.messageId,
        };
        await SendWebsocketMessage(arg.connection, 'CL_UpdateMessage', chatMessage);
    }
);
